import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { tokenCreateMock } from './token-create.mock';
var apiUrl = env.VITE_API_URL;
export var tokenHandler = [
    http.post("".concat(apiUrl, "/token/create"), function () {
        return HttpResponse.json(tokenCreateMock.success);
    }),
];
